import handlerProxy from '@/framework/common-control'
import { isAuthed, removeAuthed, removeToken } from '@/framework/utils/auth' // get token from cookie
import getPageTitle from '@/framework/utils/get-page-title'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import store from '@/framework/store'
import router from '@/framework/router'
import {getMenus} from '@/framework/utils/menu'
import i18n  from '@/i18n'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const loginPath = '/login'
// 默认的实际可访问路由，不要是redirect之前的
const indexPath = '/'

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = i18n.t(to.meta.title)
  // determine whether the user has logged in
  const hasLogined = isAuthed()
  if (hasLogined) {
    if (to.meta && to.meta.whiteList) {
      // in the free login whitelist, go directly
      next()
    } else if (to.path === loginPath) {
      // 如果为0，说明没有可访问页面

      if (store.state.user.loaded && store.state.permission.menuUrlMap.size === 0) {
        processNoPage()
        next()
        return
      }

      next({ path: indexPath })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const isDataInit = store.state.user.loaded
      if (isDataInit) {
        console.log(hasUrlPermission(to))
        if (hasUrlPermission(to)  || isDataInit) {
          next()
        } else {
          // 没有权限，直接停留在当前页面
          processNoUrlPermission(to, next, from, isDataInit)
        }
      } else {
        // 应该是刷新了页面或者首次登陆进来
        try {
          // const data = await handlerProxy.getInitData()
          // console.log(data)
          // 存储menu及操作
          let isAdmin = JSON.parse(localStorage.getItem('user')).admin
          console.log('XXXXXXXXXXXXXXXXXXX is admin:' + isAdmin)
          let data = getMenus(isAdmin)
          await store.dispatch('permission/setPermission', data)
          await store.dispatch('user/setInfo', {})

          if (hasUrlPermission(to)) {
            next({ ...to, replace: true })
            return
          } else {
            // 需要跳转到登录页面，登录页面发现已经登录，会再到首页
            // 因为这里是刷新了页面，不跳转会是空白页
            processNoUrlPermission(to, next, from, isDataInit)
          }
        } catch (error) {
          // remove token and go to login page to re-login
          // 删除token和authed
          removeToken()
          removeAuthed()
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token */
    if (to.meta && to.meta.whiteList) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      if (to.redirectedFrom && to.redirectedFrom === indexPath) {
        next(`/login`)
      } else {
        next(`/login?redirect=${to.path}`)
      }
      NProgress.done()
    }
  }
})

function hasUrlPermission(to) {
  
  // let flag = ((to.meta && to.meta.authUrl === '')
  // || store.state.permission.menuUrlMap.get(to.path)
  // || (to.meta && to.meta.authUrl && store.state.permission.menuUrlMap.get(to.meta.authUrl)))
  if(store.state.permission.menuUrlMap.constructor === Map){
  return ((to.meta && to.meta.authUrl === '')
      || store.state.permission.menuUrlMap.get(to.path)
      || (to.meta && to.meta.authUrl && store.state.permission.menuUrlMap.get(to.meta.authUrl)))
      
    }else{
  return ((to.meta && to.meta.authUrl === '')
      || store.state.permission.menuUrlMap[to.path]
      || (to.meta && to.meta.authUrl && store.state.permission.menuUrlMap[to.meta.authUrl]))

}
}

function processNoUrlPermission(to, next, from, isDataInit) {
// 没有访问此页面的权限
  NProgress.done()
  if (store.state.permission.menuUrlMap.size > 0) {
    if (to.redirectedFrom && to.redirectedFrom === indexPath) {
      // 跳转到实际访问界面
      let keys = store.state.permission.menuUrlMap.keys()
      let keysArray = [...keys]
      let nextPath = keysArray[keysArray.length - 1]
      next(nextPath)
    } else {
      if (isDataInit) {
        // 如果不是刷新或者首次登录进来的，说明当前页面有显示，停留在当前页
        Message.error('您无权访问目标页面')
      } else {
        // 由登录页面进去主界面，如果没有权限，跳转到登录页面，登录页面会转到主页面
        Message.error('您无权访问目标页面，即将跳转到主页面')
        next(loginPath)
      }
    }

  } else {
    if (from && from.path === loginPath) {
      processNoPage()
      next(false)
    } else {
      next(loginPath)
    }
  }
}

function processNoPage() {
  Message.error('不存在可访问页面，请联系管理员后重试')
}

function initInput() {
  setTimeout(() => {
    let arr = [...document.getElementsByTagName('input')]
    arr.forEach(item => {
      item.placeholder2 = item.placeholder
      if (item.value) {
        item.placeholder = ''
      }
      item.placeholder = item.placeholder2
    })
  })
}

router.afterEach(() => {
  // finish progress bar
  initInput()
  NProgress.done()
})
